export default {
  serialize: form => {
    return {
      last_name: form.lastName,
      first_name: form.firstName,
      middle_name: form.middleName,
      email: form.email,
      phone: form.phone,
      workemail: form.workemail,
      workphone: form.workphone
    };
  },
  deserialize: data => {
    const middleName = data.middle_name ? data.middle_name : '';
    const url = data.avatar; // ? process.env.VUE_APP_API_URL + '/' + data.avatar : null;
    return {
      lastName: data.last_name,
      firstName: data.first_name,
      middleName,
      email: data.email,
      phone: data.phone,
      workemail: data.workemail,
      workphone: data.workphone,
      avatar: data.avatar ? url : null
    };
  }
};
